import {
  BookEventThunk,
  JoinWaitingListThunk,
  RemoveBookedEventThunk,
  FetchEventsFilteredThunk,
  FetchEventCategoriesThunk,
  eventManagementFetchValidEventByIdThunk,
  FetchEventSubCategoriesByCategoryIdThunk,
  StartOrderCancellationProcessThunk,
} from './eventActions';
import { EventState } from './eventTypes';
import { EVENT_NAMESPACE } from './eventReducer';
import { useAppAction, useAppSelector } from '../hooks';

export function useEventSelector<T extends (state: EventState) => any>(
  selector: T
): ReturnType<T> {
  return useAppSelector((state) => selector(state[EVENT_NAMESPACE]));
}

export const useTotalPages = () =>
  useEventSelector((state) => {
    return state.totalPages;
  });

export const useTotalResults = () =>
  useEventSelector((state) => {
    return state.totalResults;
  });

export const useEvents = () =>
  useEventSelector((state) => {
    return state.events;
  });

export const useEventSubCategories = () =>
  useEventSelector((state) => {
    return state.eventsSubCategories;
  });

export const useValidEvent = () =>
  useEventSelector((state) => {
    return state.event;
  });

export const useFetchEventCategories = () =>
  useAppAction(FetchEventCategoriesThunk);

export const useFetchEventSubCategories = () =>
  useAppAction(FetchEventSubCategoriesByCategoryIdThunk);

export const useFetchFilteredEvents = () =>
  useAppAction(FetchEventsFilteredThunk);

export const useBookEvent = () => useAppAction(BookEventThunk);

export const useJoinWaitingList = () => useAppAction(JoinWaitingListThunk);

export const useCancelBookEvent = () => useAppAction(RemoveBookedEventThunk);

export const useGetValidEventById = () =>
  useAppAction(eventManagementFetchValidEventByIdThunk);

export const useStartOrderCancellationProcess = () =>
  useAppAction(StartOrderCancellationProcessThunk);
